import { Typography } from "@mui/material";

export default function SoldProductItem({ product }) {
  return <Typography>{product.nome}</Typography>;
}
